/* eslint-disable */
import React, { useRef } from 'react'
import * as THREE from 'three'
import 'react-three-fiber'

import { transformSVGPath2} from '../Utils/TransformSVG'
import StadiumPaths from '../Utils/StadiumOutfields'

// Field Components
import Infield from './Infield'
import Mound from './FieldComponents/Mound'
import Base from './FieldComponents/Base'
import HomePlate from './FieldComponents/HomePlate'

import Fence from './Fence/Fence'
// import Text from "../generic/text";

function Field(props) {
    const { outfield, hasTransform } = StadiumPaths[props.id] || {}
    const fieldPath = transformSVGPath2(outfield, hasTransform)

    const extrudeSettings = {
        depth: 1,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1,
    }
    const fieldPosition = props.position || [0, 0, 0]
    // Slightly below
    return (
        <group>
            <mesh
                receiveShadow
                castShadow
                position={fieldPosition}
                geometry={new THREE.ExtrudeGeometry(fieldPath, extrudeSettings)}
                material={
                    new THREE.MeshLambertMaterial({
                        color: 0xbbe8e4,
                        // shininess: 0.25,
                        //        specular: '#c2c2c2',
                        wireframe: false,
                        flatShading: false,
                        wireframeLinewidth: 0.4,
                        transparent: true,
                        opacity: 1,
                    })
                }
            >
            </mesh>
            <Infield {...props} />
            <Mound {...props} />
            <Base type="1b" {...props} />
            <Base type="2b" {...props} />
            <Base type="3b" {...props} />
            <HomePlate {...props} />

            <Fence
                venueId={Number(props.id)}
                position={props.position || [0, 0, 0]}
            />
        </group>
    )
}

export default Field
